import { cn } from '@/lib/utils';

export default function TitleSection({ className = '', children }) {
    return <h2 className={cn('text-2xl font-semibold leading-normal md:text-4xl lg:leading-normal', className)}>{children}</h2>;
}
